import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "workpackage-info" }, [
    _c("div", { staticClass: "section-container mb-6" }, [
      _c("div", { staticClass: "info-title mb-4" }, [
        _vm._v(_vm._s(_vm.$t("workPackages.workpackageInfo"))),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "mb-4" }, [
        _c("div", { staticClass: "info-label mb-1" }, [
          _vm._v(_vm._s(_vm.$t("workPackages.name"))),
        ]),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass:
              "info-value-box description-value d-flex justify-space-between align-center",
            on: {
              click: function ($event) {
                return _vm.selectWorkpackage()
              },
            },
          },
          [
            _c("div", [_vm._v(_vm._s(_vm.workpackage.description))]),
            _vm._v(" "),
            _c(VIcon, { attrs: { small: "", color: "#023B6E" } }, [
              _vm._v("mdi-chevron-right"),
            ]),
          ],
          1
        ),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "mb-4" }, [
        _c("div", { staticClass: "info-label mb-1" }, [
          _vm._v(_vm._s(_vm.$t("workPackages.sourceWorkpackage"))),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "info-value-box" }, [
          _c("div", [_vm._v(_vm._s(_vm.storeGroup))]),
        ]),
      ]),
      _vm._v(" "),
      _c("div", [
        _c("div", { staticClass: "d-flex" }, [
          _c("div", { staticClass: "flex-grow-1 mr-2" }, [
            _c("div", { staticClass: "info-label mb-1" }, [
              _vm._v(_vm._s(_vm.$t("workPackages.completionDate"))),
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "info-value-box d-flex align-center" },
              [
                _c(
                  VIcon,
                  {
                    staticClass: "mr-1",
                    attrs: { small: "", color: "#023B6E" },
                  },
                  [_vm._v("mdi-calendar")]
                ),
                _vm._v(" "),
                _c("span", [
                  _vm._v(
                    _vm._s(
                      _vm.formatLocalisedDate(_vm.workpackage.completionDate)
                    )
                  ),
                ]),
              ],
              1
            ),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "flex-grow-1 ml-2" }, [
            _c("div", { staticClass: "info-label mb-1" }, [
              _vm._v(_vm._s(_vm.$t("workPackages.goLiveDate"))),
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "info-value-box d-flex align-center" },
              [
                _c(
                  VIcon,
                  {
                    staticClass: "mr-1",
                    attrs: { small: "", color: "#023B6E" },
                  },
                  [_vm._v("mdi-calendar")]
                ),
                _vm._v(" "),
                _c("span", [
                  _vm._v(
                    _vm._s(_vm.formatLocalisedDate(_vm.workpackage.goLiveDate))
                  ),
                ]),
              ],
              1
            ),
          ]),
        ]),
      ]),
    ]),
    _vm._v(" "),
    _vm.workpackage.lastUpdated
      ? _c("div", { staticClass: "section-container" }, [
          _c("div", { staticClass: "d-flex align-center mb-4" }, [
            _c("div", { staticClass: "last-updated mr-2" }, [
              _vm._v(_vm._s(_vm.$t("workPackages.lastUpdated"))),
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "refresh-info d-flex" },
              [
                !_vm.isMasterWorkpackage
                  ? _c(
                      "feature-toggle",
                      { attrs: { toggle: "refreshWorkpackageFromDatabricks" } },
                      [
                        _vm.refreshing
                          ? _c("progress-spinner", {
                              attrs: {
                                "job-id": _vm.workpackage.description,
                                "job-type": "run_refresh_workpackage",
                              },
                            })
                          : _c(
                              VBtn,
                              {
                                staticClass: "refresh-btn",
                                attrs: {
                                  "x-small": "",
                                  depressed: "",
                                  disabled: _vm.disabled,
                                },
                                on: {
                                  click: function ($event) {
                                    return _vm.refreshWorkpackage({
                                      workpackageId: _vm.workpackage._id,
                                    })
                                  },
                                },
                              },
                              [_vm._m(0)],
                              1
                            ),
                      ],
                      1
                    )
                  : _vm._e(),
                _vm._v(" "),
                _c("div", { staticClass: "refresh-text" }, [
                  _c("div", [_vm._v(_vm._s(_vm.lastUpdatedText))]),
                ]),
              ],
              1
            ),
          ]),
        ])
      : _vm._e(),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c(VIcon, { attrs: { size: "2rem" } }, [_vm._v("mdi-refresh")])
  },
]
render._withStripped = true

export { render, staticRenderFns }